import { Download } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { exportTableCsv, exportTablePdf, exportTableXlsx } from "@/lib/tableExport";

export default function ExportMenu({ filename, title, columns, rows, sheetName, testId = "table-export" }) {
    const run = (format) => {
        try {
            const options = { filename, title, columns, rows, sheetName };
            if (format === "pdf") exportTablePdf(options);
            if (format === "csv") exportTableCsv(options);
            if (format === "xlsx") exportTableXlsx(options);
            toast.success(`${format.toUpperCase()} download started`);
        } catch (error) {
            console.error(`Failed to export ${format}`, error);
            toast.error(`Could not create the ${format.toUpperCase()} file`);
        }
    };

    return (
        <div className="flex flex-wrap items-center gap-1.5" aria-label="Download table">
            <span className="mr-1 hidden items-center gap-1 text-xs text-muted-foreground sm:inline-flex">
                <Download className="h-3.5 w-3.5" /> Download
            </span>
            <Button type="button" variant="outline" size="sm" onClick={() => run("pdf")} data-testid={`${testId}-pdf`} aria-label="Download PDF">PDF</Button>
            <Button type="button" variant="outline" size="sm" onClick={() => run("csv")} data-testid={`${testId}-csv`} aria-label="Download CSV">CSV</Button>
            <Button type="button" variant="outline" size="sm" onClick={() => run("xlsx")} data-testid={`${testId}-xlsx`} aria-label="Download Excel spreadsheet">XLSX</Button>
        </div>
    );
}
